var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "packages-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 100,
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "套餐名称", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入套餐名称",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "业务类型", prop: "businessTypeId" },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              on: { "on-change": _vm.changeBusinessType },
                              model: {
                                value: _vm.edit.businessTypeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "businessTypeId", $$v)
                                },
                                expression: "edit.businessTypeId",
                              },
                            },
                            _vm._l(_vm.businessTypes, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        (_vm.edit && _vm.edit.businessTypeId === 7) ||
                        _vm.applicableAge,
                      expression:
                        "(edit&&edit.businessTypeId===7)||applicableAge",
                    },
                  ],
                },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "适用起始年龄",
                            prop: "startApplicableAgeId",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.startApplicableAgeId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "startApplicableAgeId",
                                    $$v
                                  )
                                },
                                expression: "edit.startApplicableAgeId",
                              },
                            },
                            _vm._l(_vm.applicableAgeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12", "label-width": 140 } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "适用结束年龄",
                            prop: "endApplicableAgeId",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.endApplicableAgeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "endApplicableAgeId", $$v)
                                },
                                expression: "edit.endApplicableAgeId",
                              },
                            },
                            _vm._l(_vm.applicableAgeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "报告模板",
                            prop: "reportTemplateIds",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.edit.reportTemplateIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "reportTemplateIds", $$v)
                                },
                                expression: "edit.reportTemplateIds",
                              },
                            },
                            _vm._l(_vm.reportTemplates, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              rows: 3,
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检配置" } },
                        [
                          _c("EditTabPanel", {
                            ref: "editTabPanel",
                            attrs: {
                              "show-tabs": ["physicalProject", "lisProject"],
                              projectIds: _vm.edit.projectIds,
                              lisProjectIds: _vm.edit.lisProjectIds,
                            },
                            on: {
                              "update:projectIds": function ($event) {
                                return _vm.$set(_vm.edit, "projectIds", $event)
                              },
                              "update:project-ids": function ($event) {
                                return _vm.$set(_vm.edit, "projectIds", $event)
                              },
                              "update:lisProjectIds": function ($event) {
                                return _vm.$set(
                                  _vm.edit,
                                  "lisProjectIds",
                                  $event
                                )
                              },
                              "update:lis-project-ids": function ($event) {
                                return _vm.$set(
                                  _vm.edit,
                                  "lisProjectIds",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }